import ImageSlider from "../Components/ImageSlider";

function Container(props) {

  const images = [
    'https://img.freepik.com/foto-gratis/gente-vida-nocturna-divirtiendose-bares-discotecas_23-2149088562.jpg?w=2000',
    'https://static.designmynight.com/uploads/2019/07/ppyuuyuyruyr9-optimised.jpg',
    'https://pyxis.nymag.com/v1/imgs/fcb/01f/c711488f59cba7db7b68bb7baa5aaf9f72-1R5A7200.rhorizontal.w1100.jpg'
  ];

  return (
    <>
      <div className={`container mx-auto ${props.noMargin ? '' : 'mt-24 md:mt-28'} pb-10 px-4 md:px-0 lg:px-0`}>
        {props.children}
      </div>
    </>

  );
}

export default Container